import { useEffect } from 'react';
import { useIoContext } from '~/providers/IoContext';
export const biometricIdentityFromClaims = (claims)=>claims == null || claims.impersonate != null ? null : claims.email;
export const useBiometricUserSwitchGuard = ()=>{
    const { cookies, native } = useIoContext();
    useEffect(()=>{
        if (native.isNative) {
            void native.biometric.reconcileEnrolledIdentity(biometricIdentityFromClaims(cookies.getClaims()));
        }
    }, [
        native.isNative
    ]);
};
